/**
 * 全局config配置
 *
 */
const env = process.env;
export const envName = env.REACT_APP_ENV;
export const requestUrl = env.REACT_APP_REQUEST_URL;
